<p-card
	[header]="
		'presentation.app.page.profile.coach.references.diplomas.header' | translate
	"
>
	<div class="space-y-3">
		<div *ngFor="let diploma of diplomas">
			<span class="text-xs underline-none">
				{{ diploma.startDate | date: 'MM/yyyy' }} -
				{{ diploma.endDate | date: 'MM/yyyy' }} :
			</span>
			<span class="font-semibold">
				{{ diploma.name }} , {{ diploma.institution }}
			</span>
		</div>
	</div>
</p-card>
